/** Build a turn-by-turn navigation link that opens in the visitor's default maps app. */
export function directionsUrl(
  name: string,
  address: string,
  city = "Gatlinburg",
  state = "TN",
): string {
  const destination = [name, address, city, state].filter(Boolean).join(", ");
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    destination,
  )}&travelmode=driving`;
}
